import { render } from "./RoundBtn.vue?vue&type=template&id=1f050d80"
import script from "./RoundBtn.vue?vue&type=script&lang=js"
export * from "./RoundBtn.vue?vue&type=script&lang=js"

import "./RoundBtn.vue?vue&type=style&index=0&id=1f050d80&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__